import React from 'react';
import './WelcomeHeader.css';

interface WelcomeHeaderProps {
    title: string;
}

const WelcomeHeader: React.FC<WelcomeHeaderProps> = ({ title }) => (
    <header>
        <h1>{title}</h1>
    </header>
);

export default WelcomeHeader;
